import { combineReducers } from 'redux';
import label from './label';

export default combineReducers({
  label,
});